import { useObserver } from "mobx-react";
import { useState, useRef, useEffect } from "react";
import { useStores } from "../../store";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import Skills from "../JobPost/Skills";
import {
  AiOutlineClose,
  AiOutlineCode,
  AiOutlineLeft,
  AiOutlinePlus,
} from "react-icons/ai";
import { FiChevronDown, FiChevronUp, FiTrash2 } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Popup from "./Components/skipPopup";
import { uploadFileToAzure } from "../../services/azure";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { apiPostPut } from "../../api/api_methods";
import { apiDelete } from "../../api/api_methods";
import { MdOutlineAutoAwesome } from "react-icons/md";
import { toJS } from "mobx";

const LANGUAGES = [
  // {
  //   id: 45,
  //   name: "Assembly (NASM 2.14.02)",
  // },
  // {
  //   id: 46,
  //   name: "Bash (5.0.0)",
  // },
  // {
  //   id: 47,
  //   name: "Basic (FBC 1.07.1)",
  // },
  {
    id: 50,
    name: "C (GCC 9.2.0)",
  },
  {
    id: 54,
    name: "C++ (GCC 9.2.0)",
  },
  // {
  //   id: 86,
  //   name: "Clojure (1.10.1)",
  // },
  // {
  //   id: 51,
  //   name: "C# (Mono 6.6.0.161)",
  // },
  // {
  //   id: 77,
  //   name: "COBOL (GnuCOBOL 2.2)",
  // },
  // {
  //   id: 55,
  //   name: "Common Lisp (SBCL 2.0.0)",
  // },
  // {
  //   id: 56,
  //   name: "D (DMD 2.089.1)",
  // },
  // {
  //   id: 57,
  //   name: "Elixir (1.9.4)",
  // },
  // {
  //   id: 58,
  //   name: "Erlang (OTP 22.2)",
  // },
  // {
  //   id: 44,
  //   name: "Executable",
  // },
  // {
  //   id: 87,
  //   name: "F# (.NET Core SDK 3.1.202)",
  // },
  // {
  //   id: 59,
  //   name: "Fortran (GFortran 9.2.0)",
  // },
  // {
  //   id: 60,
  //   name: "Go (1.13.5)",
  // },
  // {
  //   id: 88,
  //   name: "Groovy (3.0.3)",
  // },
  // {
  //   id: 61,
  //   name: "Haskell (GHC 8.8.1)",
  // },
  {
    id: 62,
    name: "Java (OpenJDK 13.0.1)",
  },
  // {
  //   id: 63,
  //   name: "JavaScript (Node.js 12.14.0)",
  // },
  // {
  //   id: 78,
  //   name: "Kotlin (1.3.70)",
  // },
  // {
  //   id: 64,
  //   name: "Lua (5.3.5)",
  // },
  // {
  //   id: 89,
  //   name: "Multi-file program",
  // },
  // {
  //   id: 79,
  //   name: "Objective-C (Clang 7.0.1)",
  // },
  // {
  //   id: 65,
  //   name: "OCaml (4.09.0)",
  // },
  // {
  //   id: 66,
  //   name: "Octave (5.1.0)",
  // },
  // {
  //   id: 67,
  //   name: "Pascal (FPC 3.0.4)",
  // },
  // {
  //   id: 85,
  //   name: "Perl (5.28.1)",
  // },
  // {
  //   id: 68,
  //   name: "PHP (7.4.1)",
  // },
  // {
  //   id: 43,
  //   name: "Plain Text",
  // },
  // {
  //   id: 69,
  //   name: "Prolog (GNU Prolog 1.4.5)",
  // },
  {
    id: 71,
    name: "Python (3.8.1)",
  },
  // {
  //   id: 80,
  //   name: "R (4.0.0)",
  // },
  // {
  //   id: 72,
  //   name: "Ruby (2.7.0)",
  // },
  // {
  //   id: 73,
  //   name: "Rust (1.40.0)",
  // },
  // {
  //   id: 81,
  //   name: "Scala (2.13.2)",
  // },
  // {
  //   id: 82,
  //   name: "SQL (SQLite 3.27.2)",
  // },
  // {
  //   id: 83,
  //   name: "Swift (5.2.3)",
  // },
  // {
  //   id: 74,
  //   name: "TypeScript (3.7.4)",
  // },
  // {
  //   id: 84,
  //   name: "Visual Basic.Net (vbnc 0.0.0.5943)",
  // },
];

// Add at the top, after imports
const CODING_QUESTIONS_LOCAL_KEY = "lucy_coding_questions_bank";
const TASKS_BUNDLE_LOCAL_KEY = "lucy_tasks_bundle_bank";

export default function Task({ isEdit }) {
  const { CommonStore, RecuiterStore } = useStores();
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [showQuestionsPopup, setShowQuestionsPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [codingQuestions, setCodingQuestions] = useState(() => {
    // Try to load from localStorage first
    try {
      const saved = localStorage.getItem(CODING_QUESTIONS_LOCAL_KEY);
      if (saved) return JSON.parse(saved);
    } catch (e) {}
    // Fallback to MobX store if available
    if (
      RecuiterStore.jobPostDetails.taskDetails.questionBank &&
      Array.isArray(RecuiterStore.jobPostDetails.taskDetails.questionBank)
    ) {
      return [...RecuiterStore.jobPostDetails.taskDetails.questionBank];
    }
    return [];
  });

  const [tasksList, setTasksList] = useState(() => {
    // Fallback to MobX store if available
    if (
      RecuiterStore.jobPostDetails.taskDetails.tasksBank &&
      Array.isArray(RecuiterStore.jobPostDetails.taskDetails.tasksBank)
    ) {
      return [...RecuiterStore.jobPostDetails.taskDetails.tasksBank];
    }
    return [];
  });

  const [expandedTaskIdx, setExpandedTaskIdx] = useState(0);
  const toggleTaskExpand = (idx) => {
    setExpandedTaskIdx(expandedTaskIdx === idx ? null : idx);
  };

  const [editingTaskIndex, setEditingTaskIndex] = useState(null);
  const [editingTaskData, setEditingTaskData] = useState(null);

  const [codingQuestionsLoading, setCodingQuestionsLoading] = useState(false);
  const [codingQuestionsError, setCodingQuestionsError] = useState("");

  const [prompt, setPrompt] = useState("");
  const [savingTasks, setSavingTasks] = useState(false);
  const [uiNotice, setUiNotice] = useState("");
  const [showClearTasksConfirm, setShowClearTasksConfirm] = useState(false);
  const [showTaskCountModal, setShowTaskCountModal] = useState(false);
  const [taskCountInput, setTaskCountInput] = useState("10");
  const [showQuestionCountModal, setShowQuestionCountModal] = useState(false);
  const [questionCountInput, setQuestionCountInput] = useState("10");
  const [editingTaskError, setEditingTaskError] = useState("");
  const [pendingTaskDeleteIndex, setPendingTaskDeleteIndex] = useState(null);
  const [pendingQuestionDeleteId, setPendingQuestionDeleteId] = useState(null);
  const [showUnsavedTasksModal, setShowUnsavedTasksModal] = useState(false);

  // Initialize questionBank and tasksBank as empty array if they don't exist
  useEffect(() => {
    if (!RecuiterStore.jobPostDetails.taskDetails.questionBank) {
      RecuiterStore.setTaskDetails("questionBank", []);
    }
    if (!RecuiterStore.jobPostDetails.taskDetails.tasksBank) {
      RecuiterStore.setTaskDetails("tasksBank", []);
    }
  }, [RecuiterStore]);

  // Accordion state for expanded question
  const [expandedQuestionIdx, setExpandedQuestionIdx] = useState(null);
  const toggleExpand = (idx) => {
    setExpandedQuestionIdx(expandedQuestionIdx === idx ? null : idx);
  };

  useEffect(() => {
    console.log(
      toJS(RecuiterStore.jobPostDetails.taskDetails.questionBank),
      "questionBank",
    );
    if (isEdit && RecuiterStore.jobPostDetails.taskDetails.questionBank) {
      // Only set codingQuestions if it's empty to avoid overwriting existing data
      if (codingQuestions.length === 0) {
        setCodingQuestions([
          ...RecuiterStore.jobPostDetails.taskDetails.questionBank,
        ]);
      }
    }

    if (isEdit && RecuiterStore.jobPostDetails.taskDetails.tasksBank) {
      if (tasksList.length === 0) {
        setTasksList([...RecuiterStore.jobPostDetails.taskDetails.tasksBank]);
      }
    }
  }, [
    isEdit,
    RecuiterStore.jobPostDetails.taskDetails.questionBank,
    RecuiterStore.jobPostDetails.taskDetails.tasksBank,
    codingQuestions.length,
    tasksList.length,
  ]);

  // Cleanup: Reset hasUnsavedTasks when component unmounts or assessment type changes
  useEffect(() => {
    return () => {
      // Reset on unmount
      RecuiterStore.setHasUnsavedTasks(false);
    };
  }, [RecuiterStore]);

  // Reset hasUnsavedTasks when assessment type changes away from tasksBundle
  useEffect(() => {
    if (
      RecuiterStore.jobPostDetails.taskDetails.assessmentType !== "tasksBundle"
    ) {
      RecuiterStore.setHasUnsavedTasks(false);
    }
  }, [RecuiterStore.jobPostDetails.taskDetails.assessmentType, RecuiterStore]);

  // Reset hasUnsavedTasks when section is skipped
  useEffect(() => {
    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
      RecuiterStore.setHasUnsavedTasks(false);
    }
  }, [RecuiterStore.jobPostDetails.taskDetails.skipped, RecuiterStore]);

  // Auto-generate default prompt for tasksBundle based on job details
  useEffect(() => {
    if (
      RecuiterStore.jobPostDetails.taskDetails.assessmentType ===
        "tasksBundle" &&
      !prompt
    ) {
      const jobTitle =
        RecuiterStore.jobPostDetails.basicJobDetails.jobTitle ||
        "[Job Role Name]";
      const skills =
        RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills || [];

      // Split skills into primary (first 3) and secondary (rest)
      const primarySkills = skills.slice(0, 3).join(", ") || "[Primary Skills]";
      const secondarySkills =
        skills.slice(3).join(", ") || "[Secondary Skills]";

      const defaultPrompt = `Create a list of projects for the job role ${jobTitle}. These projects should evaluate the core skills required for this role such as ${primarySkills}${secondarySkills !== "[Secondary Skills]" ? ` and ${secondarySkills}` : ""}. Each project must include:

• A short title
• A clear goal or problem to solve
• The skills that will be measured
• An expected time to complete
• A simple final deliverable or outcome

Ensure the projects are realistic, industry relevant, and achievable within 1-2 weeks. Include a variety of difficulties such as beginner, intermediate, and advanced. Keep language simple so students can easily understand.`;

      setPrompt(defaultPrompt);
    }
  }, [
    RecuiterStore.jobPostDetails.taskDetails.assessmentType,
    RecuiterStore.jobPostDetails.basicJobDetails.jobTitle,
    RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills,
  ]);

  const getFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    const filename = urlParts[urlParts.length - 1];
    const cleanFilename = filename.replace(/^\d+_/, "");
    return cleanFilename.substring(17);
  };

  const handleFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    setLoading(true);

    try {
      for (const file of files) {
        const timestamp = Date.now().toString();
        const min = 1000;
        const max = 9999;
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        const filename = randomNumber + timestamp + file.name;

        const fileUploaded = await uploadFileToAzure(filename, file, {
          action: "profile",
        });

        if (fileUploaded?.success) {
          const fileType = file.type.startsWith("image/")
            ? "image"
            : file.type.startsWith("video/")
              ? "video"
              : file.type.startsWith("audio/")
                ? "audio"
                : "document";

          const mediaObject = {
            type: fileType,
            url: fileUploaded.url,
          };

          const currentMedia =
            RecuiterStore.jobPostDetails.taskDetails.media || [];
          RecuiterStore.setTaskDetails("media", [...currentMedia, mediaObject]);
        }
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setLoading(false);
    }
  };

  const removeFile = (index) => {
    const currentMedia = RecuiterStore.jobPostDetails.taskDetails.media || [];
    const updatedStoreMedia = currentMedia.filter((_, i) => i !== index);
    RecuiterStore.setTaskDetails("media", updatedStoreMedia);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    handleFileUpload({ target: { files } });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { assessmentType, levelOfInterview, languageId, noOfQuestions } =
      RecuiterStore.jobPostDetails.taskDetails;

    // Check for unsaved tasks before proceeding
    if (assessmentType === "tasksBundle" && RecuiterStore.hasUnsavedTasks) {
      setShowUnsavedTasksModal(true);
      return;
    }

    // Centralized validation for coding flow
    if (assessmentType === "coding") {
      const count = Number(noOfQuestions);
      if (!levelOfInterview || !languageId || !Number.isInteger(count)) {
        setUiNotice(
          "Please select level, language, and a valid question count.",
        );
        return;
      }
      if (count < 1 || count > 5) {
        setUiNotice("Number of questions should be between 1 and 5.");
        return;
      }
    }

    if (uiNotice) {
      setUiNotice("");
    }

    if (showClearTasksConfirm) {
      setShowClearTasksConfirm(false);
    }
    if (showTaskCountModal) {
      setShowTaskCountModal(false);
    }
    if (showQuestionCountModal) {
      setShowQuestionCountModal(false);
    }
    if (editingTaskError) {
      setEditingTaskError("");
    }

    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
      RecuiterStore.setTaskDetails("skipped", false);
      CommonStore.setLabelSkipped(5, false);
    }
    CommonStore.setProgress(CommonStore.progress + 1);
    CommonStore.setLabelActive(6, true);
  };

  const handleBack = () => {
    CommonStore.setProgress(CommonStore.progress - 1);
  };

  // Coding questions state

  // Helper to check if store questions match current filter
  const currentLanguageId = RecuiterStore.jobPostDetails.taskDetails.languageId;
  const currentLevel =
    RecuiterStore.jobPostDetails.taskDetails.levelOfInterview;
  function storeMatchesCurrentFilter() {
    if (
      !Array.isArray(RecuiterStore.codingQuestionsBank) ||
      RecuiterStore.codingQuestionsBank.length === 0
    )
      return false;
    // Check if all questions match the current languageId and level
    return RecuiterStore.codingQuestionsBank.every(
      (q) =>
        String(q.languageId) === String(currentLanguageId) &&
        q.levelOfQuestion === currentLevel,
    );
  }

  useEffect(() => {
    console.log(codingQuestions, "codingQuestions");
    // Ensure questionBank is always an array
    if (!RecuiterStore.jobPostDetails.taskDetails.questionBank) {
      RecuiterStore.setTaskDetails("questionBank", []);
    }

    // Only update questionBank if we're not in edit mode or if the questionBank is empty
    // This prevents overwriting the original questionBank structure in edit mode
    if (
      !isEdit ||
      RecuiterStore.jobPostDetails.taskDetails.questionBank.length === 0
    ) {
      RecuiterStore.setTaskDetails("questionBank", [...codingQuestions]);
    }

    console.log(
      RecuiterStore.jobPostDetails.taskDetails.questionBank,
      "questionBank",
    );
  }, [codingQuestions, isEdit, RecuiterStore]);

  const fetchCodingQuestions = async () => {
    setCodingQuestionsError("");
    if (
      isEdit &&
      RecuiterStore.jobPostDetails.taskDetails.questionBank.length > 0
    ) {
      console.log(
        RecuiterStore.jobPostDetails.taskDetails.questionBank,
        "questionBank",
      );
      setCodingQuestions([
        ...RecuiterStore.jobPostDetails.taskDetails.questionBank,
      ]);
      return;
    }
    setCodingQuestions([]);
    setCodingQuestionsLoading(true);
    try {
      if (!currentLanguageId || !currentLevel) {
        setCodingQuestionsError(
          "Please select both language and level to view coding questions.",
        );
        setCodingQuestionsLoading(false);
        return;
      }
      if (
        RecuiterStore.jobPostDetails.taskDetails.questionBank &&
        RecuiterStore.jobPostDetails.taskDetails.questionBank.length > 0
      ) {
        setCodingQuestions([
          ...RecuiterStore.jobPostDetails.taskDetails.questionBank,
        ]);
        setCodingQuestionsLoading(false);
        return;
      }
      // Use store if already loaded for this filter
      if (storeMatchesCurrentFilter()) {
        setCodingQuestions([...RecuiterStore.codingQuestionsBank]);
        setCodingQuestionsLoading(false);
        return;
      }
      const payload = {
        languageId: parseInt(currentLanguageId),
        levelOfQuestion: currentLevel,
        ignore: [],
        noOfQuestions:
          parseInt(RecuiterStore.jobPostDetails.taskDetails.noOfQuestions) ||
          10,
      };
      const response = await apiPostPut(
        payload,
        "/v1/coding-questions/search-quetions-by-filter",
        "POST",
      );
      if (
        response.status === 200 &&
        response.body.success &&
        Array.isArray(response.body.data)
      ) {
        RecuiterStore.setCodingQuestionsBank(response.body.data);
        setCodingQuestions([...response.body.data]);
        const currentQuestionBank =
          RecuiterStore.jobPostDetails.taskDetails.questionBank || [];
        RecuiterStore.setTaskDetails("questionBank", [
          ...currentQuestionBank,
          ...response.body.data,
        ]);
      } else {
        setCodingQuestionsError(
          "No coding questions found for the selected language and level.",
        );
      }
    } catch (err) {
      setCodingQuestionsError(
        "Failed to fetch coding questions. Please try again.",
      );
    } finally {
      setCodingQuestionsLoading(false);
    }
  };

  // Fetch coding questions when popup opens
  useEffect(() => {
    if (
      showQuestionsPopup &&
      RecuiterStore.jobPostDetails.taskDetails.assessmentType === "coding"
    ) {
      fetchCodingQuestions();
    }
  }, [
    showQuestionsPopup,
    currentLanguageId,
    currentLevel,
    RecuiterStore.jobPostDetails.taskDetails.assessmentType,
  ]);

  // Auto-fetch questions in background once level + language are both selected
  useEffect(() => {
    if (
      !isEdit &&
      RecuiterStore.jobPostDetails.taskDetails.assessmentType === "coding" &&
      currentLanguageId &&
      currentLevel
    ) {
      // Clear cached bank so fetchCodingQuestions always hits the API for the new filter
      RecuiterStore.setTaskDetails("questionBank", []);
      RecuiterStore.setCodingQuestionsBank([]);
      fetchCodingQuestions();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguageId, currentLevel]);

  // When deleting a question, update both store and local state
  const handleDeleteCodingQuestion = (id) => {
    RecuiterStore.removeCodingQuestionById(id);
    setCodingQuestions((prev) => {
      const updated = prev.filter((q) => q._id !== id);
      // In edit mode, also update the questionBank to keep it in sync
      if (isEdit) {
        RecuiterStore.setTaskDetails("questionBank", [...updated]);
      }
      return updated;
    });
  };

  const handleDeleteTask = (index) => {
    setTasksList((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      RecuiterStore.setTaskDetails("tasksBank", [...updated]);

      // Mark as unsaved
      RecuiterStore.setHasUnsavedTasks(true);

      return updated;
    });
  };

  // Verify test cases for an existing question
  const handleVerifyQuestionTestCases = async (question) => {
    if (
      !question.code ||
      !question.testCases ||
      question.testCases.length === 0
    ) {
      alert("This question has no code or test cases to verify.");
      return;
    }

    const languageId = RecuiterStore.jobPostDetails.taskDetails.languageId;
    if (!languageId) {
      alert("Please select a language before verifying test cases.");
      return;
    }

    const updatedQuestion = { ...question };
    let verifiedCount = 0;
    let failedCount = 0;

    for (let idx = 0; idx < updatedQuestion.testCases.length; idx++) {
      const testCase = updatedQuestion.testCases[idx];

      try {
        const response = await RecuiterStore.compileCode(
          question.code,
          parseInt(languageId),
          testCase.input,
        );

        if (response && response.status === "Accepted") {
          const actualOutput = response.output.trim();
          const expectedOutput = testCase.expectedOutput.trim();

          if (actualOutput === expectedOutput) {
            updatedQuestion.testCases[idx] = { ...testCase, isVerified: true };
            verifiedCount++;
          } else {
            updatedQuestion.testCases[idx] = { ...testCase, isVerified: false };
            failedCount++;
          }
        } else {
          updatedQuestion.testCases[idx] = { ...testCase, isVerified: false };
          failedCount++;
        }
      } catch (error) {
        console.error(`Error verifying test case ${idx + 1}:`, error);
        updatedQuestion.testCases[idx] = { ...testCase, isVerified: false };
        failedCount++;
      }
    }

    // Update the question in both local state and store
    setCodingQuestions((prev) => {
      const updated = prev.map((q) =>
        q._id === question._id ? updatedQuestion : q,
      );
      // In edit mode, also update the questionBank to keep it in sync
      if (isEdit) {
        RecuiterStore.setTaskDetails("questionBank", [...updated]);
      }
      return updated;
    });
    RecuiterStore.updateCodingQuestionById(question._id, updatedQuestion);

    if (verifiedCount > 0 && failedCount === 0) {
      alert(
        `All test cases verified successfully! ✅ (${verifiedCount} passed)`,
      );
    } else if (verifiedCount > 0 && failedCount > 0) {
      alert(
        `Test case verification completed!\n✅ ${verifiedCount} passed\n❌ ${failedCount} failed`,
      );
    } else {
      alert(`All test cases failed verification! ❌ (${failedCount} failed)`);
    }
  };

  // Add this state for the add-question popup
  const [showAddQuestionOptions, setShowAddQuestionOptions] = useState(false);
  const [generatingAIQuestions, setGeneratingAIQuestions] = useState(false);
  const [showManualQuestionModal, setShowManualQuestionModal] = useState(false);
  const [manualForm, setManualForm] = useState({
    question: "",
    code: "",
    explanation: "",
    levelOfQuestion: RecuiterStore.jobPostDetails.taskDetails.levelOfInterview,
    testCases: [{ input: "", expectedOutput: "", description: "" }],
    supportedLanguageIds: [],
  });
  const [manualFormError, setManualFormError] = useState("");
  const [manualFormLoading, setManualFormLoading] = useState(false);
  const [manualSubmitOverride, setManualSubmitOverride] = useState(false);
  const [verifyingTestCases, setVerifyingTestCases] = useState({});

  // Handle click outside for the add-question popup
  const addQuestionOptionsRef = useRef();
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        addQuestionOptionsRef.current &&
        !addQuestionOptionsRef.current.contains(event.target)
      ) {
        setShowAddQuestionOptions(false);
      }
    }
    if (showAddQuestionOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showAddQuestionOptions]);

  // Handler for Auto Generate
  const handleAutoGenerate = async () => {
    setShowAddQuestionOptions(false);
    const languageId = RecuiterStore.jobPostDetails.taskDetails.languageId;
    const levelOfQuestion =
      RecuiterStore.jobPostDetails.taskDetails.levelOfInterview;
    if (!languageId || !levelOfQuestion) {
      setUiNotice(
        "Please select language and level before auto-generating questions.",
      );
      return;
    }
    setQuestionCountInput("10");
    setShowQuestionCountModal(true);
  };

  const runAutoGenerate = async () => {
    const noOfQuestions = parseInt(questionCountInput, 10);
    if (
      Number.isNaN(noOfQuestions) ||
      noOfQuestions < 1 ||
      noOfQuestions > 50
    ) {
      setUiNotice("Please enter a valid question count between 1 and 50.");
      return;
    }
    setShowQuestionCountModal(false);

    setGeneratingAIQuestions(true);
    try {
      const languageId = RecuiterStore.jobPostDetails.taskDetails.languageId;
      const levelOfQuestion =
        RecuiterStore.jobPostDetails.taskDetails.levelOfInterview;
      const payload = {
        languageId: parseInt(languageId),
        levelOfQuestion,
        ignore: codingQuestions.map((q) => q._id).filter(Boolean),
        noOfQuestions,
      };
      const response = await apiPostPut(
        payload,
        "/v1/coding-questions/search-quetions-by-filter",
        "POST",
      );
      if (
        response.status === 200 &&
        response.body.success &&
        Array.isArray(response.body.data)
      ) {
        // Append new questions to store and local state
        const newQuestions = response.body.data;
        if (newQuestions.length > 0) {
          RecuiterStore.setCodingQuestionsBank([
            ...RecuiterStore.codingQuestionsBank,
            ...newQuestions,
          ]);
          setCodingQuestions((prev) => {
            const updated = [...prev, ...newQuestions];
            // In edit mode, also update the questionBank to keep it in sync
            if (isEdit) {
              RecuiterStore.setTaskDetails("questionBank", [...updated]);
            }
            return updated;
          });
        } else {
          alert("No new questions found.");
        }
        // alert('Auto-generated questions added!');
      } else {
        alert("Failed to auto-generate questions.");
      }
    } catch (err) {
      alert("Failed to auto-generate questions.");
    } finally {
      setGeneratingAIQuestions(false);
    }
  };

  const handleAutoGenerateCode = async () => {
    // Only allow if question is filled
    if (!manualForm.question.trim()) {
      setManualFormError(
        "Please enter a question before auto-generating code.",
      );
      return;
    }
    const languageId = parseInt(
      RecuiterStore.jobPostDetails.taskDetails.languageId,
    );
    const language = LANGUAGES.find((l) => l.id === languageId)?.name;
    const levelOfQuestion =
      RecuiterStore.jobPostDetails.taskDetails.levelOfInterview;
    if (!languageId || !language || !levelOfQuestion) {
      setManualFormError(
        "Please select language and level before auto-generating code.",
      );
      return;
    }
    setManualFormLoading(true);
    setManualFormError("");
    try {
      const payload = {
        language,
        languageId,
        levelOfQuestion,
        question: manualForm.question.trim(),
      };
      const response = await apiPostPut(
        payload,
        "/coding-questions/generate-coding-questions",
        "POST",
      );
      if (
        response.status === 200 &&
        response.body.success &&
        response.body.data &&
        Array.isArray(response.body.data.data) &&
        response.body.data.data.length > 0
      ) {
        const generated = response.body.data.data[0];
        setManualForm((f) => ({
          ...f,
          code: generated.code || "",
          explanation: generated.explanation || "",
          testCases: Array.isArray(generated.testCases)
            ? generated.testCases.map((tc) => ({
                input: tc.input || "",
                expectedOutput: tc.expectedOutput || "",
                description: tc.description || "",
                isVerified: undefined,
              }))
            : [{ input: "", expectedOutput: "", description: "" }],
          levelOfQuestion: generated.levelOfQuestion || levelOfQuestion,
          supportedLanguageIds: Array.isArray(generated.supportedLanguageIds)
            ? generated.supportedLanguageIds
            : [languageId],
        }));
      } else {
        setManualFormError("Failed to auto-generate code. Please try again.");
      }
    } catch (err) {
      setManualFormError("Failed to auto-generate code. Please try again.");
    } finally {
      setManualFormLoading(false);
    }
  };

  // Handler for manual question modal open
  const handleOpenManualModal = () => {
    const currentLanguageId =
      RecuiterStore.jobPostDetails.taskDetails.languageId;
    setManualForm({
      question: "",
      code: "",
      explanation: "",
      levelOfQuestion:
        RecuiterStore.jobPostDetails.taskDetails.levelOfInterview || "",
      testCases: [{ input: "", expectedOutput: "", description: "" }],
      supportedLanguageIds: currentLanguageId
        ? [parseInt(currentLanguageId)]
        : [],
    });
    setManualFormError("");
    setVerifyingTestCases({});
    setShowManualQuestionModal(true);
  };

  // Handler for manual form submit
  const handleManualFormSubmit = async (e) => {
    e.preventDefault();
    setManualFormError("");
    // Validation
    if (
      !manualForm.question.trim() ||
      !manualForm.code.trim() ||
      !manualForm.explanation.trim() ||
      !manualForm.levelOfQuestion.trim()
    ) {
      setManualFormError("All fields are required.");
      return;
    }
    // if (
    //   !manualForm.testCases.length ||
    //   manualForm.testCases.some(
    //     (tc) => !tc.input.trim() || !tc.expectedOutput.trim()
    //   )
    // ) {
    //   setManualFormError("All test cases must have input and expected output.");
    //   return;
    // }
    if (!manualForm.supportedLanguageIds.length) {
      setManualFormError("Please select at least one supported language.");
      return;
    }

    // Ensure current language is always included in supported languages
    const currentLanguageId = parseInt(
      RecuiterStore.jobPostDetails.taskDetails.languageId,
    );
    if (
      currentLanguageId &&
      !manualForm.supportedLanguageIds.includes(currentLanguageId)
    ) {
      setManualFormError(
        "The current selected language must be included in supported languages.",
      );
      return;
    }

    // Check if all test cases are verified
    const unverifiedTestCases = manualForm.testCases.filter(
      (tc) => tc.isVerified !== true,
    );
    if (unverifiedTestCases.length > 0) {
      if (!manualSubmitOverride) {
        setManualFormError(
          `${unverifiedTestCases.length} test case(s) are not verified. Click submit again to continue anyway.`,
        );
        setManualSubmitOverride(true);
        return;
      }
    } else if (manualSubmitOverride) {
      setManualSubmitOverride(false);
    }

    const languageId = RecuiterStore.jobPostDetails.taskDetails.languageId;
    const language = LANGUAGES.find(
      (l) => String(l.id) === String(languageId),
    )?.name;
    if (!languageId || !language) {
      setManualFormError("Language is required.");
      return;
    }
    setManualFormLoading(true);
    try {
      const payload = {
        question: manualForm.question,
        code: manualForm.code,
        explanation: manualForm.explanation,
        testCases: manualForm.testCases.map((tc) => ({
          input: tc.input,
          expectedOutput: tc.expectedOutput,
          description: tc.description,
          isVerified: tc.isVerified || false,
        })),
        levelOfQuestion: manualForm.levelOfQuestion,
        language,
        languageId: parseInt(languageId),
        supportedLanguageIds: manualForm.supportedLanguageIds,
      };
      const response = await apiPostPut(
        payload,
        "/coding-questions/add-question",
        "POST",
      );
      if (
        response.status === 200 &&
        response.body.success &&
        response.body.data
      ) {
        setCodingQuestions((prev) => {
          const updated = [...prev, response.body.data];
          // In edit mode, also update the questionBank to keep it in sync
          if (isEdit) {
            RecuiterStore.setTaskDetails("questionBank", [...updated]);
          }
          return updated;
        });
        RecuiterStore.setCodingQuestionsBank([
          ...RecuiterStore.codingQuestionsBank,
          response.body.data,
        ]);
        setShowManualQuestionModal(false);
        alert("Question added successfully!");
      } else {
        setManualFormError("Failed to add question.");
      }
    } catch (err) {
      setManualFormError("Failed to add question.");
    } finally {
      setManualFormLoading(false);
    }
  };

  // Handler for test case changes
  const handleTestCaseChange = (idx, field, value) => {
    setManualForm((f) => ({
      ...f,
      testCases: f.testCases.map((tc, i) =>
        i === idx ? { ...tc, [field]: value, isVerified: undefined } : tc,
      ),
    }));
  };

  // Handler to add/remove test case
  const handleAddTestCase = () => {
    setManualForm((f) => ({
      ...f,
      testCases: [
        ...f.testCases,
        { input: "", expectedOutput: "", description: "" },
      ],
    }));
  };
  const handleRemoveTestCase = (idx) => {
    setManualForm((f) => ({
      ...f,
      testCases: f.testCases.filter((_, i) => i !== idx),
    }));
  };

  // Handler for test case verification
  const handleVerifyTestCase = async (idx) => {
    const testCase = manualForm.testCases[idx];
    if (!manualForm.code.trim()) {
      alert(
        "Please fill in the code, test case input, and expected output before verifying.",
      );
      return;
    }

    setVerifyingTestCases((prev) => ({ ...prev, [idx]: true }));

    try {
      const languageId = RecuiterStore.jobPostDetails.taskDetails.languageId;
      if (!languageId) {
        alert("Please select a language before verifying test cases.");
        return;
      }

      const response = await RecuiterStore.compileCode(
        manualForm.code,
        parseInt(languageId),
        testCase.input,
      );

      if (response && response.status === "Accepted") {
        // Normalize outputs for comparison (remove trailing whitespace and newlines)
        const actualOutput = response.output.trim();
        const expectedOutput = testCase.expectedOutput.trim();

        if (actualOutput === expectedOutput) {
          // Update the test case with verification status
          setManualForm((f) => ({
            ...f,
            testCases: f.testCases.map((tc, i) =>
              i === idx ? { ...tc, isVerified: true } : tc,
            ),
          }));
          alert(`Test case ${idx + 1} verified successfully! ✅`);
        } else {
          alert(
            `Test case ${
              idx + 1
            } failed! ❌\nExpected: "${expectedOutput}"\nActual: "${actualOutput}"`,
          );
        }
      } else {
        alert(
          `Test case ${idx + 1} failed to compile or execute! ❌\nError: ${
            response?.output || "Unknown error"
          }`,
        );
      }
    } catch (error) {
      console.error("Verification error:", error);
      alert(`Failed to verify test case ${idx + 1}. Please try again.`);
    } finally {
      setVerifyingTestCases((prev) => ({ ...prev, [idx]: false }));
    }
  };

  // Handler for verifying all test cases
  const handleVerifyAllTestCases = async () => {
    if (!manualForm.code.trim()) {
      alert("Please enter the code before verifying test cases.");
      return;
    }

    const testCasesToVerify = manualForm.testCases.filter(
      (tc) => tc.input.trim() && tc.expectedOutput.trim(),
    );
    if (testCasesToVerify.length === 0) {
      alert(
        "Please add at least one test case with input and expected output before verifying.",
      );
      return;
    }

    const languageId = RecuiterStore.jobPostDetails.taskDetails.languageId;
    if (!languageId) {
      alert("Please select a language before verifying test cases.");
      return;
    }

    // Set all to verifying
    let verifyingObj = {};
    manualForm.testCases.forEach((tc, idx) => {
      verifyingObj[idx] = "verifying";
    });
    setVerifyingTestCases(verifyingObj);

    try {
      const updatedTestCases = [...manualForm.testCases];
      let verifiedCount = 0;
      let failedCount = 0;

      for (let idx = 0; idx < updatedTestCases.length; idx++) {
        const testCase = updatedTestCases[idx];

        try {
          const response = await RecuiterStore.compileCode(
            manualForm.code,
            parseInt(languageId),
            testCase.input,
          );

          if (response && response.status === "Accepted") {
            const actualOutput = response.output.trim();
            const expectedOutput = testCase.expectedOutput.trim();

            if (actualOutput === expectedOutput) {
              updatedTestCases[idx] = { ...testCase, isVerified: true };
              setVerifyingTestCases((prev) => ({ ...prev, [idx]: "verified" }));
              verifiedCount++;
            } else {
              updatedTestCases[idx] = { ...testCase, isVerified: false };
              setVerifyingTestCases((prev) => ({ ...prev, [idx]: "failed" }));
              failedCount++;
            }
          } else {
            updatedTestCases[idx] = { ...testCase, isVerified: false };
            setVerifyingTestCases((prev) => ({ ...prev, [idx]: "failed" }));
            failedCount++;
          }
        } catch (error) {
          console.error(`Error verifying test case ${idx + 1}:`, error);
          updatedTestCases[idx] = { ...testCase, isVerified: false };
          setVerifyingTestCases((prev) => ({ ...prev, [idx]: "failed" }));
          failedCount++;
        }
      }

      setManualForm((f) => ({ ...f, testCases: updatedTestCases }));

      if (verifiedCount > 0 && failedCount === 0) {
        alert(
          `All test cases verified successfully! ✅ (${verifiedCount} passed)`,
        );
      } else if (verifiedCount > 0 && failedCount > 0) {
        alert(
          `Test case verification completed!\n✅ ${verifiedCount} passed\n❌ ${failedCount} failed`,
        );
      } else {
        alert(`All test cases failed verification! ❌ (${failedCount} failed)`);
      }
    } catch (error) {
      console.error("Bulk verification error:", error);
      alert("Failed to verify test cases. Please try again.");
    } finally {
      // Clear all verifying statuses
      setVerifyingTestCases({});
    }
  };

  // Handler for supported language selection
  const handleSupportedLanguageChange = (languageId, isChecked) => {
    const currentLanguageId = parseInt(
      RecuiterStore.jobPostDetails.taskDetails.languageId,
    );

    // Prevent removing the current language
    if (!isChecked && languageId === currentLanguageId) {
      return;
    }

    setManualForm((f) => ({
      ...f,
      supportedLanguageIds: isChecked
        ? [...f.supportedLanguageIds, languageId]
        : f.supportedLanguageIds.filter((id) => id !== languageId),
    }));
  };

  // Helper function to get language names from IDs
  const getLanguageNames = (languageIds) => {
    if (!languageIds || !Array.isArray(languageIds)) return [];
    return languageIds
      .map((id) => LANGUAGES.find((lang) => lang.id === id)?.name)
      .filter(Boolean);
  };

  // On mount, restore from localStorage or MobX store if available
  useEffect(() => {
    let restored = null;
    try {
      const saved = localStorage.getItem(CODING_QUESTIONS_LOCAL_KEY);
      if (saved) restored = JSON.parse(saved);
    } catch (e) {}

    // In edit mode, prioritize the store's questionBank over localStorage
    if (
      isEdit &&
      RecuiterStore.jobPostDetails.taskDetails.questionBank &&
      Array.isArray(RecuiterStore.jobPostDetails.taskDetails.questionBank) &&
      RecuiterStore.jobPostDetails.taskDetails.questionBank.length > 0
    ) {
      setCodingQuestions([
        ...RecuiterStore.jobPostDetails.taskDetails.questionBank,
      ]);
    } else if (restored && Array.isArray(restored) && restored.length > 0) {
      setCodingQuestions(restored);
      // Only update store if not in edit mode
      if (!isEdit) {
        RecuiterStore.setTaskDetails("questionBank", restored);
      }
    } else if (
      RecuiterStore.jobPostDetails.taskDetails.questionBank &&
      Array.isArray(RecuiterStore.jobPostDetails.taskDetails.questionBank) &&
      RecuiterStore.jobPostDetails.taskDetails.questionBank.length > 0
    ) {
      setCodingQuestions([
        ...RecuiterStore.jobPostDetails.taskDetails.questionBank,
      ]);
    }
    // Do NOT reset to [] here
    // eslint-disable-next-line
  }, [isEdit]);

  // Whenever codingQuestions changes, persist to localStorage and MobX store
  useEffect(() => {
    try {
      localStorage.setItem(
        CODING_QUESTIONS_LOCAL_KEY,
        JSON.stringify(codingQuestions),
      );
    } catch (e) {}

    // Only update MobX store if different and not in edit mode
    // In edit mode, we want to preserve the original questionBank structure
    if (
      !isEdit &&
      JSON.stringify(RecuiterStore.jobPostDetails.taskDetails.questionBank) !==
        JSON.stringify(codingQuestions)
    ) {
      RecuiterStore.setTaskDetails("questionBank", [...codingQuestions]);
    }
    // ... existing code ...
  }, [codingQuestions, isEdit, RecuiterStore]);

  // Whenever tasksList changes, persist to localStorage and MobX store
  useEffect(() => {
    try {
      localStorage.setItem(TASKS_BUNDLE_LOCAL_KEY, JSON.stringify(tasksList));
    } catch (e) {}

    if (
      !isEdit &&
      JSON.stringify(RecuiterStore.jobPostDetails.taskDetails.tasksBank) !==
        JSON.stringify(tasksList)
    ) {
      RecuiterStore.setTaskDetails("tasksBank", [...tasksList]);
    }
  }, [tasksList, isEdit, RecuiterStore]);

  const generateTasks = async (isAddMore, noOfTasks = 10, tasksBank = []) => {
    if (!prompt.trim()) {
      alert("Please enter a prompt to generate tasks.");
      return;
    }

    let newPrompt = prompt;

    if (tasksBank?.length > 0) {
      newPrompt +=
        "\nExclude the following tasks: " +
        tasksBank?.map((task) => task.title).join(", ");
    }

    setLoading(true);
    try {
      const payload = {
        prompt: newPrompt,
        noOfTasks: noOfTasks,
      };

      const response = await apiPostPut(payload, "/v1/tasks/generate", "POST");

      if (response.status === 200 && response.body.success) {
        const generatedTasks = response.body.data;

        // Assuming generatedTasks is an array of task objects
        if (Array.isArray(generatedTasks)) {
          setTasksList((prev) => {
            const updated = [...prev, ...generatedTasks];
            if (isEdit) {
              RecuiterStore.setTaskDetails("tasksBank", [...updated]);
            }
            return updated;
          });

          // Also update the store directly
          RecuiterStore.setTaskDetails("tasksBank", [
            ...(RecuiterStore.jobPostDetails.taskDetails.tasksBank || []),
            ...generatedTasks,
          ]);

          // Mark tasks as unsaved
          RecuiterStore.setHasUnsavedTasks(true);

          alert("Tasks generated successfully!");
        } else {
          console.error("Unexpected response format:", response.body);
          alert("Failed to generate tasks: Unexpected response format.");
        }
      } else {
        alert(
          response.body?.message ||
            "Failed to generate tasks. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error generating tasks:", error);
      alert("An error occurred while generating tasks.");
    } finally {
      setLoading(false);
    }
  };

  const handleClearTasks = () => {
    setShowClearTasksConfirm(true);
  };

  const validateListInput = (value) =>
    value
      .split(",")
      .map((entry) => entry.trim())
      .filter(Boolean)
      .every((entry) => /^[a-zA-Z0-9\s\-+#&/.()]{1,50}$/.test(entry));

  const handleGenerateMoreTasks = () => {
    const count = parseInt(taskCountInput, 10);
    if (Number.isNaN(count) || count < 1 || count > 20) {
      setUiNotice("Please enter a valid task count between 1 and 20.");
      return;
    }
    setShowTaskCountModal(false);
    generateTasks(
      true,
      count,
      RecuiterStore.jobPostDetails.taskDetails.tasksBank,
    );
  };

  const handleSaveTasks = async () => {
    if (!tasksList || tasksList.length === 0) {
      alert("No tasks to save. Please generate or add tasks first.");
      return;
    }

    setSavingTasks(true);
    try {
      const payload = {
        tasks: tasksList,
      };

      const response = await apiPostPut(
        payload,
        "/v1/tasks/add-multiple",
        "POST",
      );

      if (response.status === 200 && response.body.success) {
        RecuiterStore.setTaskDetails("tasksBank", response.body.data);
        setTasksList(response.body.data);

        // Mark tasks as saved
        RecuiterStore.setHasUnsavedTasks(false);

        console.log(
          "Tasks saved successfully!",
          toJS(RecuiterStore.jobPostDetails.taskDetails.tasksBank),
        );
        alert("Tasks saved successfully!");
        // Optionally clear the tasks list after successful save
        // setTasksList([]);
        // RecuiterStore.setTaskDetails("tasksBank", []);
      } else {
        alert(
          response.body?.message || "Failed to save tasks. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error saving tasks:", error);
      alert("An error occurred while saving tasks.");
    } finally {
      setSavingTasks(false);
    }
  };

  const saveAndProceed = async () => {
    if (!tasksList || tasksList.length === 0) {
      setShowUnsavedTasksModal(false);
      return;
    }
    setSavingTasks(true);
    try {
      const response = await apiPostPut(
        { tasks: tasksList },
        "/v1/tasks/add-multiple",
        "POST",
      );
      if (response.status === 200 && response.body.success) {
        RecuiterStore.setTaskDetails("tasksBank", response.body.data);
        setTasksList(response.body.data);
        RecuiterStore.setHasUnsavedTasks(false);
        setShowUnsavedTasksModal(false);
        CommonStore.setProgress(CommonStore.progress + 1);
        CommonStore.setLabelActive(6, true);
      } else {
        setShowUnsavedTasksModal(false);
        setUiNotice(
          response.body?.message || "Failed to save tasks. Please try again.",
        );
      }
    } catch (error) {
      setShowUnsavedTasksModal(false);
      setUiNotice("An error occurred while saving tasks.");
    } finally {
      setSavingTasks(false);
    }
  };

  return useObserver(() => (
    <div className="w-full  px-12">
      <div className="flex justify-center">
        <div className="flex items-center w-[92%] md:ml-0 lg:ml-0 ml-[15rem] mx-auto justify-between">
          <p className="text-xl font-semibold text-black mb-2 md:block mt-10 lg:block md:ml-20 hidden">
            Add Task
          </p>
          {RecuiterStore.jobPostDetails.taskDetails.skipped && isEdit ? (
            <div className="flex gap-2 flex-col">
              <button
                type="button"
                className="text-gray-400 underline cursor-not-allowed"
              >
                Skip Section
              </button>
              <p className="text-primary">This section is skipped</p>
            </div>
          ) : (
            <button
              type="button"
              onClick={() => setShowPopup(true)}
              className="text-primary underline ml-56 md:mt-10 mt-4"
            >
              Skip Section
            </button>
          )}
        </div>
      </div>
      <p className="text-xl font-semibold md:hidden lg:hidden block text-center -mt-6 md:mt-0 lg:mt-0 text-black flex sm:justify-start ml-5">
        Add Task
      </p>

      <form
        onSubmit={isEdit ? (e) => e.preventDefault() : handleSubmit}
        className="w-[90%] mx-auto mt-2"
      >
        {isEdit && (
          <div className="mb-4 rounded-lg bg-orange-50 border border-orange-200 px-4 py-3 text-sm text-orange-800">
            Task details are locked and cannot be modified after a job post is
            created.
          </div>
        )}
        <div className="relative">
          {isEdit && (
            <div className="absolute inset-0 z-10 cursor-not-allowed rounded-lg" />
          )}
          {uiNotice ? (
            <div className="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
              {uiNotice}
            </div>
          ) : null}
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-1 md:gap-6 w-full mx-auto">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Task Type
              </label>
              <select
                value={RecuiterStore.jobPostDetails.taskDetails.assessmentType}
                onChange={(e) => {
                  if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                    RecuiterStore.setTaskDetails("skipped", false);
                    CommonStore.setLabelSkipped(5, "false");
                  }
                  RecuiterStore.setTaskDetails(
                    "assessmentType",
                    e.target.value,
                  );
                  if (e.target.value === "coding") {
                    RecuiterStore.setTaskDetails("noOfQuestions", 5);
                  }
                }}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                required
              >
                <option value="">Select Task Type</option>
                <option value="coding">Coding</option>
                {/* <option value="mcqs">MCQs</option> */}
                <option value="caseStudy">Case Study</option>
                <option value="project">Project</option>
                <option value="tasksBundle">Multiple Tasks</option>
                <option value="other">Others</option>
              </select>
            </div>
            {RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
              "coding" &&
              RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
                "tasksBundle" && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Task Name
                  </label>
                  <input
                    type="text"
                    value={RecuiterStore.jobPostDetails.taskDetails.title}
                    onChange={(e) => {
                      if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                        RecuiterStore.setTaskDetails("skipped", false);
                        CommonStore.setLabelSkipped(5, "false");
                      }
                      RecuiterStore.setTaskDetails("title", e.target.value);
                    }}
                    placeholder="Enter task title"
                    className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                    required
                  />
                </div>
              )}
            {RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
              "tasksBundle" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Duration (
                  {RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
                  "coding"
                    ? "in days"
                    : "in minutes"}
                  )
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={RecuiterStore.jobPostDetails.taskDetails.duration}
                  onChange={(e) => {
                    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                      RecuiterStore.setTaskDetails("skipped", false);
                      CommonStore.setLabelSkipped(5, "false");
                    }
                    RecuiterStore.setTaskDetails(
                      "duration",
                      Math.max(0, parseInt(e.target.value)),
                    );
                  }}
                  placeholder="Enter duration"
                  min="0"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                  required
                />
              </div>
            )}
            {RecuiterStore.jobPostDetails.taskDetails.assessmentType ===
              "coding" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Cut Off (optional)
                </label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={RecuiterStore.jobPostDetails.taskDetails.cutOff}
                  onChange={(e) => {
                    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                      RecuiterStore.setTaskDetails("skipped", false);
                      CommonStore.setLabelSkipped(5, "false");
                    }
                    RecuiterStore.setTaskDetails(
                      "cutOff",
                      Math.max(0, parseInt(e.target.value)),
                    );
                  }}
                  placeholder="Enter cut off (in %)"
                  min="0"
                  max="100"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                />
              </div>
            )}
          </div>

          {RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
            "coding" &&
            RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
              "tasksBundle" && (
              <div className="mt-8">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Task Description
                </label>
                <div className="h-64">
                  <ReactQuill
                    theme="snow"
                    value={RecuiterStore.jobPostDetails.taskDetails.description}
                    onChange={(content) => {
                      if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                        RecuiterStore.setTaskDetails("skipped", false);
                        CommonStore.setLabelSkipped(5, "false");
                      }
                      RecuiterStore.setTaskDetails("description", content);
                    }}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        ["bold", "italic", "underline", "strike"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ indent: "-1" }, { indent: "+1" }],
                        ["link"],
                        // ['clean']
                      ],
                    }}
                    formats={[
                      "header",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "list",
                      "bullet",
                      "indent",
                      "link",
                      "image",
                    ]}
                    placeholder="Enter task description"
                    className="h-48"
                  />
                </div>
              </div>
            )}

          {RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
            "coding" &&
            RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
              "tasksBundle" && (
              <div className="mt-8">
                <Skills
                  lab="Suggested Technologies/Tools"
                  Skills={["React", "Node.js", "Python", "Java", "JavaScript"]}
                  setaddedSkills={(skill) => {
                    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                      RecuiterStore.setTaskDetails("skipped", false);
                      CommonStore.setLabelSkipped(5, "false");
                    }
                    const currentTech =
                      RecuiterStore.jobPostDetails.taskDetails.technologyUsed ||
                      [];

                    if (!currentTech.includes(skill)) {
                      RecuiterStore.setTaskDetails("technologyUsed", [
                        ...currentTech,
                        skill,
                      ]);
                    }
                  }}
                  removeSkills={(index) => {
                    const currentTech =
                      RecuiterStore.jobPostDetails.taskDetails.technologyUsed ||
                      [];
                    RecuiterStore.setTaskDetails(
                      "technologyUsed",
                      currentTech.filter((_, i) => i !== index),
                    );
                  }}
                  value={
                    RecuiterStore.jobPostDetails.taskDetails.technologyUsed
                  }
                />
              </div>
            )}
          {RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
            "coding" &&
            RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
              "tasksBundle" && (
              <div className="mt-8">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Level of Task
                </label>
                <div className="flex gap-4">
                  {["low", "medium", "high"].map((level) => (
                    <label key={level} className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="level"
                        required
                        value={level}
                        checked={
                          RecuiterStore.jobPostDetails.taskDetails
                            .levelOfAssessment === level
                        }
                        onChange={(e) => {
                          if (
                            RecuiterStore.jobPostDetails.taskDetails.skipped
                          ) {
                            RecuiterStore.setTaskDetails("skipped", false);
                            CommonStore.setLabelSkipped(5, "false");
                          }
                          RecuiterStore.setTaskDetails(
                            "levelOfAssessment",
                            e.target.value,
                          );
                        }}
                        className="text-primary"
                      />
                      <span className="capitalize">{level}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
          {RecuiterStore.jobPostDetails.taskDetails.assessmentType ===
            "coding" && (
            <div className="grid mt-8 grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-1 md:gap-6 w-full mx-auto">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Level of Task
                </label>
                <select
                  value={
                    RecuiterStore.jobPostDetails.taskDetails.levelOfInterview
                  }
                  onChange={(e) => {
                    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                      RecuiterStore.setTaskDetails("skipped", false);
                      CommonStore.setLabelSkipped(5, "false");
                    }
                    RecuiterStore.setTaskDetails(
                      "levelOfInterview",
                      e.target.value,
                    );
                  }}
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                >
                  <option value="">Select Level of Task</option>
                  <option value="beginner">Beginner</option>
                  {/* <option value="mcqs">MCQs</option> */}
                  <option value="intermediate">Intermediate</option>
                  <option value="advanced">Advanced</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select the language
                </label>
                <select
                  value={RecuiterStore.jobPostDetails.taskDetails.languageId}
                  onChange={(e) => {
                    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                      RecuiterStore.setTaskDetails("skipped", false);
                      CommonStore.setLabelSkipped(5, "false");
                    }
                    RecuiterStore.setTaskDetails("languageId", e.target.value);
                  }}
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                  required
                >
                  <option value="">Select the language</option>
                  {LANGUAGES.map((lang) => (
                    <option key={lang.id} value={lang.id}>
                      {lang.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Number of Questions
                </label>
                <input
                  type="text"
                  value={RecuiterStore.jobPostDetails.taskDetails.noOfQuestions}
                  onChange={(e) => {
                    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                      RecuiterStore.setTaskDetails("skipped", false);
                      CommonStore.setLabelSkipped(5, "false");
                    }
                    const sanitized = e.target.value.replace(/[^\d]/g, "");
                    if (sanitized !== "" && parseInt(sanitized, 10) > 5) {
                      setUiNotice(
                        "Maximum 5 questions allowed. Value has been set to 5.",
                      );
                      RecuiterStore.setTaskDetails("noOfQuestions", "5");
                    } else {
                      if (uiNotice) setUiNotice("");
                      RecuiterStore.setTaskDetails("noOfQuestions", sanitized);
                    }
                  }}
                  placeholder="Enter Number of Questions (max 5)"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                  min={1}
                  max={5}
                />
              </div>
            </div>
          )}

          {RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
            "coding" &&
            RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
              "tasksBundle" && (
              <div className="mt-8">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  GitHub Repository Link (Optional)
                </label>
                <input
                  type="url"
                  value={RecuiterStore.jobPostDetails.taskDetails.githubLink}
                  onChange={(e) => {
                    if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                      RecuiterStore.setTaskDetails("skipped", false);
                      CommonStore.setLabelSkipped(5, "false");
                    }
                    RecuiterStore.setTaskDetails("githubLink", e.target.value);
                  }}
                  placeholder="Enter GitHub repository link"
                  className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
                />
              </div>
            )}
          {RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
            "coding" &&
            RecuiterStore.jobPostDetails.taskDetails.assessmentType !==
              "tasksBundle" && (
              <div className="mt-8">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Media Files
                </label>
                <div
                  className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center h-40 flex flex-col items-center justify-center cursor-pointer hover:border-primary transition-colors duration-300"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  onClick={() => fileInputRef.current.click()}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                    multiple
                    className="hidden"
                  />
                  {RecuiterStore.jobPostDetails.taskDetails.media?.length ===
                    0 ||
                  RecuiterStore.jobPostDetails.taskDetails.media ===
                    undefined ? (
                    <p className="text-gray-500">
                      Drag and drop files here or click to upload
                    </p>
                  ) : (
                    <div className="w-full h-full relative flex flex-wrap gap-2 items-start justify-start">
                      {RecuiterStore.jobPostDetails.taskDetails.media?.map(
                        (file, index) => (
                          <div
                            key={index}
                            className="w-fit flex border border-gray-300 rounded-lg items-center gap-2 p-2"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <span className="truncate">
                              {getFileNameFromUrl(file.url)}
                            </span>
                            <button
                              type="button"
                              onClick={() => removeFile(index)}
                              className="text-red-500 hover:text-red-700"
                            >
                              <AiOutlineClose />
                            </button>
                          </div>
                        ),
                      )}
                      <button
                        type="button"
                        onClick={() => fileInputRef.current.click()}
                        className="mt-2 absolute bottom-0 right-[45%] flex items-center gap-2 text-primary hover:text-primary-dark"
                      >
                        <AiOutlinePlus /> Add More Files
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

          {RecuiterStore.jobPostDetails.taskDetails.assessmentType ===
            "coding" && (
            <div className="my-8">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Coding Questions Preview
              </label>
              <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 w-full">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-lg flex items-center justify-center mx-auto md:mx-0">
                      <span className="text-white font-semibold text-lg md:text-xl">
                        {codingQuestions.length > 0
                          ? codingQuestions.length
                          : RecuiterStore.jobPostDetails.taskDetails
                              .noOfQuestions || 5}
                      </span>
                    </div>
                    <div className="flex flex-col items-center md:items-start text-center md:text-left w-full">
                      <p className="font-medium text-gray-900 text-base md:text-lg">
                        {codingQuestions.length > 0
                          ? codingQuestions.length
                          : RecuiterStore.jobPostDetails.taskDetails
                              .noOfQuestions || 5}{" "}
                        Coding Questions
                      </p>
                      <p className="text-xs md:text-sm text-gray-600">
                        Level:{" "}
                        {RecuiterStore.jobPostDetails.taskDetails
                          .levelOfInterview || "Not selected"}
                      </p>
                      <p className="text-xs md:text-sm text-gray-600">
                        Language:{" "}
                        {LANGUAGES.find(
                          (lang) =>
                            lang.id ===
                            parseInt(
                              RecuiterStore.jobPostDetails.taskDetails
                                .languageId,
                            ),
                        )?.name || "Not selected"}
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setShowQuestionsPopup(true)}
                    className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors w-full md:w-auto"
                  >
                    View Questions Bank
                  </button>
                </div>
              </div>
            </div>
          )}

          {RecuiterStore.jobPostDetails.taskDetails.assessmentType ===
            "tasksBundle" && (
            <div className="mt-8">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Prompt
              </label>
              <textarea
                value={prompt}
                rows={4}
                onChange={(e) => {
                  if (RecuiterStore.jobPostDetails.taskDetails.skipped) {
                    RecuiterStore.setTaskDetails("skipped", false);
                    CommonStore.setLabelSkipped(5, "false");
                  }
                  setPrompt(e.target.value);
                }}
                placeholder="Enter prompt here"
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none"
              />
              {tasksList.length < 1 && (
                <div className="flex justify-end">
                  <button
                    type="button"
                    onClick={() => generateTasks()}
                    disabled={loading}
                    className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors flex justify-end items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                    {loading && (
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8z"
                        ></path>
                      </svg>
                    )}
                    {loading ? "Generating..." : "Generate"}
                  </button>
                </div>
              )}
            </div>
          )}

          {RecuiterStore.jobPostDetails.taskDetails.assessmentType ===
            "tasksBundle" &&
            tasksList.length > 0 && (
              <div className="mt-8 space-y-4">
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-semibold text-gray-900">
                    Generated Tasks ({tasksList.length})
                  </h3>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={handleSaveTasks}
                      disabled={savingTasks || loading}
                      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      {savingTasks && (
                        <svg
                          className="animate-spin h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8z"
                          ></path>
                        </svg>
                      )}
                      {savingTasks ? "Saving..." : "Save Tasks"}
                    </button>
                    <button
                      type="button"
                      onClick={handleClearTasks}
                      disabled={loading || savingTasks}
                      className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      Clear All
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setTaskCountInput("10");
                        setShowTaskCountModal(true);
                      }}
                      disabled={loading || savingTasks}
                      className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors flex justify-end items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                    >
                      {loading && (
                        <svg
                          className="animate-spin h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8z"
                          ></path>
                        </svg>
                      )}
                      {loading
                        ? "Generating..."
                        : tasksList.length > 0
                          ? "Add More"
                          : "Generate"}
                    </button>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-4">
                  {tasksList.map((task, index) => (
                    <div
                      key={index}
                      className={`border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow relative group cursor-pointer ${expandedTaskIdx === index ? "ring-1 ring-primary" : ""}`}
                      onClick={() => toggleTaskExpand(index)}
                    >
                      <div className="flex justify-between items-start">
                        <h4 className="font-semibold text-lg text-primary mb-2 flex-1 pr-8">
                          {index + 1}.{" "}
                          {task.task || task.title || "Untitled Task"}
                        </h4>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditingTaskIndex(index);
                              setEditingTaskData({
                                ...task,
                                toolsString: task.tools?.join(", ") || "",
                                categoriesString:
                                  task.categories?.join(", ") || "",
                              });
                            }}
                            className="text-gray-400 hover:text-blue-500 transition-colors p-1"
                            title="Edit Task"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 0 0 0 2 2h14a2 0 0 0 2-2v-7"></path>
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                            </svg>
                          </button>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setPendingTaskDeleteIndex(index);
                            }}
                            className="text-gray-400 hover:text-red-500 transition-colors p-1"
                            title="Remove Task"
                          >
                            <FiTrash2 size={18} />
                          </button>
                          {expandedTaskIdx === index ? (
                            <FiChevronUp size={20} className="text-gray-400" />
                          ) : (
                            <FiChevronDown
                              size={20}
                              className="text-gray-400"
                            />
                          )}
                        </div>
                      </div>

                      {expandedTaskIdx === index && (
                        <div className="mt-2">
                          <p className="text-gray-600 text-sm mb-3 whitespace-pre-wrap">
                            {task.description}
                          </p>

                          <div className="flex flex-wrap gap-4 text-sm text-gray-500 mb-3">
                            {task.duration && (
                              <div className="flex items-center gap-1">
                                <span className="font-medium text-gray-700">
                                  Duration:
                                </span>
                                <span>{task.duration} days</span>
                              </div>
                            )}
                            {task.technology && (
                              <div className="flex items-center gap-1">
                                <span className="font-medium text-gray-700">
                                  Tech:
                                </span>
                                <span>{task.technology}</span>
                              </div>
                            )}
                          </div>

                          <div className="space-y-2">
                            {task.categories && task.categories.length > 0 && (
                              <div className="flex flex-wrap gap-2">
                                <span className="font-medium text-gray-700">
                                  Categories:
                                </span>
                                {task.categories.map((cat, i) => (
                                  <span
                                    key={i}
                                    className="px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded-full border border-blue-100"
                                  >
                                    {cat}
                                  </span>
                                ))}
                              </div>
                            )}
                            {task.tools && task.tools.length > 0 && (
                              <div className="flex flex-wrap gap-2">
                                <span className="font-medium text-gray-700">
                                  Tools:
                                </span>
                                {task.tools.map((tool, i) => (
                                  <span
                                    key={i}
                                    className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded-full border border-gray-200"
                                  >
                                    {tool}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

          {/* Edit Task Modal */}
          {editingTaskIndex !== null && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl mx-4 p-6 relative overflow-y-auto max-h-[90vh]">
                <button
                  className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
                  onClick={() => {
                    setEditingTaskIndex(null);
                    setEditingTaskData(null);
                  }}
                >
                  <AiOutlineClose size={24} />
                </button>
                <h2 className="text-2xl font-bold mb-6 text-gray-900">
                  Edit Task
                </h2>

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Task Title
                    </label>
                    <input
                      type="text"
                      value={
                        editingTaskData?.title || editingTaskData?.task || ""
                      }
                      onChange={(e) =>
                        setEditingTaskData({
                          ...editingTaskData,
                          title: e.target.value,
                          task: e.target.value,
                        })
                      }
                      className="w-full p-2 border border-gray-300 rounded-lg focus:outline-primary"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Description
                    </label>
                    <textarea
                      value={editingTaskData?.description || ""}
                      onChange={(e) =>
                        setEditingTaskData({
                          ...editingTaskData,
                          description: e.target.value,
                        })
                      }
                      rows={4}
                      className="w-full p-2 border border-gray-300 rounded-lg focus:outline-primary"
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Duration (days)
                      </label>
                      <input
                        type="number"
                        value={editingTaskData?.duration || ""}
                        onChange={(e) =>
                          setEditingTaskData({
                            ...editingTaskData,
                            duration: e.target.value,
                          })
                        }
                        className="w-full p-2 border border-gray-300 rounded-lg focus:outline-primary"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Technology
                      </label>
                      <input
                        type="text"
                        value={editingTaskData?.technology || ""}
                        onChange={(e) =>
                          setEditingTaskData({
                            ...editingTaskData,
                            technology: e.target.value,
                          })
                        }
                        className="w-full p-2 border border-gray-300 rounded-lg focus:outline-primary"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Categories (comma separated)
                    </label>
                    <input
                      type="text"
                      value={editingTaskData?.categoriesString || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEditingTaskData({
                          ...editingTaskData,
                          categoriesString: value,
                        });
                        if (!validateListInput(value)) {
                          setEditingTaskError(
                            "Categories can contain letters, numbers, spaces, and - + # & / . ( ) only.",
                          );
                        } else {
                          setEditingTaskError("");
                        }
                      }}
                      placeholder="e.g. Frontend, UI/UX"
                      className="w-full p-2 border border-gray-300 rounded-lg focus:outline-primary"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Tools (comma separated)
                    </label>
                    <input
                      type="text"
                      value={editingTaskData?.toolsString || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setEditingTaskData({
                          ...editingTaskData,
                          toolsString: value,
                        });
                        if (!validateListInput(value)) {
                          setEditingTaskError(
                            "Tools can contain letters, numbers, spaces, and - + # & / . ( ) only.",
                          );
                        } else {
                          setEditingTaskError("");
                        }
                      }}
                      placeholder="e.g. VS Code, Figma"
                      className="w-full p-2 border border-gray-300 rounded-lg focus:outline-primary"
                    />
                  </div>
                  {editingTaskError ? (
                    <p className="text-sm text-red-600">{editingTaskError}</p>
                  ) : null}

                  <div className="flex justify-end gap-3 mt-6">
                    <button
                      type="button"
                      onClick={() => {
                        setEditingTaskIndex(null);
                        setEditingTaskData(null);
                      }}
                      className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 font-medium"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        if (
                          !editingTaskData?.title?.trim() &&
                          !editingTaskData?.task?.trim()
                        ) {
                          setEditingTaskError("Task title is required.");
                          return;
                        }
                        if (
                          !validateListInput(
                            editingTaskData?.toolsString || "",
                          ) ||
                          !validateListInput(
                            editingTaskData?.categoriesString || "",
                          )
                        ) {
                          setEditingTaskError(
                            "Please enter valid comma-separated categories and tools.",
                          );
                          return;
                        }

                        const updatedTask = {
                          ...editingTaskData,
                          tools: editingTaskData.toolsString
                            ? editingTaskData.toolsString
                                .split(",")
                                .map((s) => s.trim())
                                .filter(Boolean)
                            : [],
                          categories: editingTaskData.categoriesString
                            ? editingTaskData.categoriesString
                                .split(",")
                                .map((s) => s.trim())
                                .filter(Boolean)
                            : [],
                        };
                        delete updatedTask.toolsString;
                        delete updatedTask.categoriesString;

                        setTasksList((prev) => {
                          const updated = [...prev];
                          updated[editingTaskIndex] = updatedTask;

                          RecuiterStore.setTaskDetails("tasksBank", [
                            ...updated,
                          ]);

                          // Mark as unsaved after editing
                          RecuiterStore.setHasUnsavedTasks(true);

                          return updated;
                        });

                        setEditingTaskIndex(null);
                        setEditingTaskData(null);
                        setEditingTaskError("");
                      }}
                      className="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary-dark font-medium"
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* end read-only wrapper */}

        <div className="flex justify-between mt-0 md:mt-20 pb-20 md:pb-10 lg:mt-20 mb-20">
          <button
            type="button"
            className="text-primary flex items-center gap-2 mb-3 md:mt-0 lg:mt-0  "
            onClick={handleBack}
          >
            <AiOutlineLeft /> Back
          </button>
          <PrimaryButton
            buttonName="Next"
            width="w-fit"
            type={
              RecuiterStore.jobPostDetails.taskDetails.skipped && isEdit
                ? "button"
                : "submit"
            }
            onClick={async () => {
              if (
                !RecuiterStore.jobPostDetails.taskDetails.questionBank ||
                RecuiterStore.jobPostDetails.taskDetails.questionBank.length ===
                  0
              ) {
                await fetchCodingQuestions();
                // return;
              }
              // if (RecuiterStore.jobPostDetails.taskDetails.questionBank.length < parseInt(RecuiterStore.jobPostDetails.taskDetails.noOfQuestions)) {
              //   alert("Please add more questions");
              //   return;
              // }
              if (RecuiterStore.jobPostDetails.taskDetails.skipped && isEdit) {
                RecuiterStore.setTaskDetails("skipped", true);
                CommonStore.setProgress(6);
                CommonStore.setLabelActive(5, false);
                CommonStore.setLabelSkipped(5, true);
              } else {
                CommonStore.setLabelSkipped(5, false);
                RecuiterStore.setTaskDetails("skipped", false);
                CommonStore.setLabelActive(5, true);
                if (isEdit) {
                  CommonStore.setProgress(6);
                }
              }
            }}
            padding={10}
            rounded="lg"
          />
        </div>
      </form>

      {showUnsavedTasksModal ? (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-xl w-full max-w-md p-6 shadow-2xl">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
                <svg
                  className="w-5 h-5 text-orange-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">
                Unsaved Tasks
              </h3>
            </div>
            <p className="text-sm text-gray-600 mb-1">
              You have generated tasks that haven't been saved yet.
            </p>
            <p className="text-sm text-gray-600">
              Please save your tasks before moving to the next step, or they
              will be lost.
            </p>
            <div className="mt-6 flex justify-end gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 font-medium text-sm"
                onClick={() => setShowUnsavedTasksModal(false)}
              >
                Go Back
              </button>
              <button
                type="button"
                disabled={savingTasks}
                className="px-4 py-2 rounded-lg bg-primary text-white hover:opacity-90 font-medium text-sm disabled:opacity-60"
                onClick={saveAndProceed}
              >
                {savingTasks ? "Saving..." : "Save & Continue"}
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {showClearTasksConfirm ? (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-lg w-full max-w-md p-5 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-900">
              Clear all tasks?
            </h3>
            <p className="text-sm text-gray-600 mt-2">
              This will remove all generated tasks from the current bundle.
            </p>
            <div className="mt-5 flex justify-end gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                onClick={() => setShowClearTasksConfirm(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600"
                onClick={() => {
                  setTasksList([]);
                  RecuiterStore.setTaskDetails("tasksBank", []);
                  RecuiterStore.setHasUnsavedTasks(true);
                  setShowClearTasksConfirm(false);
                }}
              >
                Clear
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {showTaskCountModal ? (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-lg w-full max-w-md p-5 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-900">
              Add more tasks
            </h3>
            <p className="text-sm text-gray-600 mt-2">
              Enter task count (1-20).
            </p>
            <input
              type="number"
              min={1}
              max={20}
              value={taskCountInput}
              onChange={(e) => setTaskCountInput(e.target.value)}
              className="mt-3 w-full p-2 border border-gray-300 rounded-lg focus:outline-primary"
            />
            <div className="mt-5 flex justify-end gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                onClick={() => setShowTaskCountModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary-dark"
                onClick={handleGenerateMoreTasks}
              >
                Generate
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {showQuestionCountModal ? (
        <div className="fixed inset-0 bg-black/40 z-[60] flex items-center justify-center px-4">
          <div className="bg-white rounded-lg w-full max-w-md p-5 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-900">
              Auto-generate questions
            </h3>
            <p className="text-sm text-gray-600 mt-2">
              Current questions: {codingQuestions.length}. Enter question count
              (1-10).
            </p>
            <input
              type="number"
              min={1}
              max={10}
              value={questionCountInput}
              onChange={(e) => setQuestionCountInput(e.target.value)}
              className="mt-3 w-full p-2 border border-gray-300 rounded-lg focus:outline-primary"
            />
            <div className="mt-5 flex justify-end gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                onClick={() => setShowQuestionCountModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary-dark"
                onClick={runAutoGenerate}
              >
                Generate
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {pendingTaskDeleteIndex !== null ? (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-lg w-full max-w-md p-5 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-900">
              Delete task?
            </h3>
            <p className="text-sm text-gray-600 mt-2">
              This removes the selected task from your list.
            </p>
            <div className="mt-5 flex justify-end gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                onClick={() => setPendingTaskDeleteIndex(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600"
                onClick={() => {
                  handleDeleteTask(pendingTaskDeleteIndex);
                  setPendingTaskDeleteIndex(null);
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {pendingQuestionDeleteId ? (
        <div className="fixed inset-0 bg-black/40 z-[60] flex items-center justify-center px-4">
          <div className="bg-white rounded-lg w-full max-w-md p-5 shadow-xl">
            <h3 className="text-lg font-semibold text-gray-900">
              Delete question?
            </h3>
            <p className="text-sm text-gray-600 mt-2">
              This removes the question from the current list.
            </p>
            <div className="mt-5 flex justify-end gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                onClick={() => setPendingQuestionDeleteId(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600"
                onClick={() => {
                  handleDeleteCodingQuestion(pendingQuestionDeleteId);
                  setPendingQuestionDeleteId(null);
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {showPopup && (
        <Popup
          onSkip={() => {
            RecuiterStore.setTaskDetails("skipped", true);
            setShowPopup(false);
            CommonStore.setProgress(6);
            CommonStore.setLabelActive(5, false);
            CommonStore.setLabelSkipped(5, true);
          }}
          onFillDetails={() => setShowPopup(false)}
        />
      )}

      {/* Questions Popup */}
      {showQuestionsPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg px-2 py-4 md:p-8 w-full max-w-full md:max-w-2xl lg:max-w-4xl xl:max-w-6xl max-h-[90vh] overflow-y-auto shadow-2xl">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-2 md:gap-0">
              <h2 className="text-xl md:text-2xl font-semibold text-gray-900 text-center md:text-left">
                Coding Questions Preview
              </h2>
              <button
                onClick={() => setShowQuestionsPopup(false)}
                className="text-gray-500 hover:text-gray-700 self-end md:self-auto mt-2 md:mt-0"
              >
                <AiOutlineClose size={28} />
              </button>
            </div>
            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-medium text-blue-900 mb-2 text-base md:text-lg">
                  Assessment Details
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-4 text-sm">
                  <div>
                    <span className="font-medium">Level:</span>
                    <span className="ml-2 text-blue-700 capitalize">
                      {RecuiterStore.jobPostDetails.taskDetails
                        .levelOfInterview || "Not selected"}
                    </span>
                  </div>
                  <div>
                    <span className="font-medium">Language:</span>
                    <span className="ml-2 text-blue-700">
                      {LANGUAGES.find(
                        (lang) =>
                          lang.id ===
                          parseInt(
                            RecuiterStore.jobPostDetails.taskDetails.languageId,
                          ),
                      )?.name || "Not selected"}
                    </span>
                  </div>
                  <div>
                    <span className="font-medium">Total Questions:</span>
                    <span className="ml-2 text-blue-700">
                      {codingQuestions.length}
                    </span>
                  </div>
                </div>
                <div className="mt-3 mb-1 bg-blue-50 rounded px-3 py-2 text-blue-700 text-sm">
                  The number of questions will be randomly picked from the below
                  question bank for the candidate.
                </div>
              </div>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3 gap-2 md:gap-0">
                  <h3 className="font-medium text-gray-900 text-base md:text-lg">
                    Questions
                  </h3>
                  <div className="relative w-full md:w-auto">
                    <button
                      type="button"
                      className="flex items-center gap-2 px-3 py-1.5 bg-primary text-white rounded hover:bg-primary-dark transition-colors shadow w-full md:w-auto justify-center md:justify-start"
                      onClick={() => setShowAddQuestionOptions((v) => !v)}
                      disabled={generatingAIQuestions}
                    >
                      <AiOutlinePlus /> Add More Questions
                    </button>
                    {showAddQuestionOptions && (
                      <div
                        ref={addQuestionOptionsRef}
                        className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50"
                      >
                        <button
                          className="w-full text-left px-4 py-2 hover:bg-gray-100 text-gray-800 rounded-t-lg"
                          onClick={handleAutoGenerate}
                          disabled={generatingAIQuestions}
                        >
                          {generatingAIQuestions
                            ? "Generating..."
                            : "Auto Generate"}
                        </button>
                        <button
                          className="w-full text-left px-4 py-2 hover:bg-gray-100 text-gray-800 rounded-b-lg"
                          onClick={() => {
                            setShowAddQuestionOptions(false);
                            handleOpenManualModal();
                          }}
                          disabled={generatingAIQuestions}
                        >
                          Enter Manually
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                {generatingAIQuestions || codingQuestionsLoading ? (
                  <div className="space-y-3" data-testid="shimmer-loader">
                    {[1, 2, 3, 4].map((_, idx) => (
                      <div
                        key={idx}
                        className="bg-white border rounded-lg p-0 md:p-0 relative transition-all duration-200 mb-2 shadow-sm border-gray-200 animate-pulse"
                        style={{ minHeight: 64 }}
                      >
                        <div className="flex items-center px-4 py-3 md:py-4">
                          <div className="flex-shrink-0">
                            <div className="w-10 h-10 md:w-12 md:h-12 bg-gray-200 rounded-full flex items-center justify-center text-lg font-bold shadow-md border-4 border-white" />
                          </div>
                          <div className="flex-1 min-w-0 ml-4">
                            <div className="flex items-center justify-between">
                              <div className="flex-1 min-w-0">
                                <div className="h-4 bg-gray-200 rounded w-2/3 mb-2" />
                                <div className="h-3 bg-gray-100 rounded w-1/2" />
                              </div>
                              <div className="ml-2">
                                <div className="w-6 h-6 bg-gray-200 rounded-full" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="px-4 pb-4">
                          <div className="h-3 bg-gray-100 rounded w-3/4 mb-2" />
                          <div className="h-3 bg-gray-100 rounded w-1/2 mb-2" />
                          <div className="h-3 bg-gray-100 rounded w-2/3 mb-2" />
                          <div className="h-3 bg-gray-100 rounded w-1/3" />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : codingQuestionsError ? (
                  <div className="text-center py-8 text-red-500 font-medium">
                    {codingQuestionsError}
                  </div>
                ) : codingQuestions.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">
                    No coding questions found for the selected language and
                    level.
                  </div>
                ) : (
                  <div className="space-y-3">
                    {codingQuestions.map((q, idx) => {
                      const expanded = expandedQuestionIdx === idx;
                      return (
                        <div
                          key={q.question || idx}
                          className={`group bg-white border rounded-lg p-0 md:p-0 relative transition-all duration-200 mb-2 ${
                            expanded
                              ? "shadow-2xl border-primary bg-blue-50"
                              : "shadow-sm border-gray-200 hover:shadow-md"
                          } cursor-pointer`}
                          style={{ minHeight: 64 }}
                          onClick={(e) => {
                            // Prevent expand/collapse when clicking delete
                            if (e.target.closest(".delete-btn")) return;
                            toggleExpand(idx);
                          }}
                        >
                          <div className="flex items-center px-4 py-3 md:py-4">
                            <div className="flex-shrink-0">
                              <div className="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-full flex items-center justify-center text-white text-lg font-bold shadow-md border-4 border-white">
                                {idx + 1}
                              </div>
                            </div>
                            <div className="flex-1 min-w-0 ml-4">
                              <div className="flex items-center justify-between">
                                <div className="flex-1 min-w-0">
                                  <h4 className="font-semibold text-gray-900 text-base md:text-lg mb-1 truncate">
                                    {q.question}
                                  </h4>
                                  {!expanded && (
                                    <p className="text-gray-600 text-xs md:text-sm mb-0 truncate">
                                      {q.explanation}
                                    </p>
                                  )}
                                  {/* {!expanded && q.supportedLanguageIds && q.supportedLanguageIds.length > 0 && (
                                    <div className="flex items-center gap-1 mt-1">
                                      <span className="text-xs text-gray-500">Languages:</span>
                                      <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
                                        {q.supportedLanguageIds.length} supported
                                      </span>
                                    </div>
                                  )} */}
                                </div>
                                <div className="flex items-center ml-2 gap-2">
                                  {/* <button
                                    type="button"
                                    className="text-blue-500 hover:text-blue-700 p-1 rounded-full transition-colors"
                                    title="Verify Test Cases"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleVerifyQuestionTestCases(q);
                                    }}
                                  >
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                      />
                                    </svg>
                                  </button> */}
                                  <button
                                    type="button"
                                    className="delete-btn text-red-500 hover:text-red-700 p-1 rounded-full transition-colors"
                                    title="Delete Question"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setPendingQuestionDeleteId(q._id);
                                    }}
                                  >
                                    <FiTrash2 size={22} />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {expanded && (
                            <>
                              <hr className="my-2 border-gray-200" />
                              <div className="px-4 pb-4">
                                <p className="text-gray-600 text-sm mb-3">
                                  {q.explanation}
                                </p>
                                {/* {q.supportedLanguageIds && q.supportedLanguageIds.length > 0 && (
                                  <div className="bg-blue-50 rounded p-3 mb-3">
                                    <p className="text-sm font-medium text-blue-900 mb-2">
                                      Supported Languages:
                                    </p>
                                    <div className="flex flex-wrap gap-1">
                                      {getLanguageNames(q.supportedLanguageIds).map((langName, index) => {
                                        const langId = q.supportedLanguageIds[index];
                                        const isPrimary = q.languageId && langId === q.languageId;
                                        return (
                                          <span
                                            key={index}
                                            className={`inline-block text-xs px-2 py-1 rounded-full ${
                                              isPrimary 
                                                ? 'bg-blue-200 text-blue-900 font-medium border border-blue-300'
                                                : 'bg-blue-100 text-blue-800'
                                            }`}
                                          >
                                            {langName}{isPrimary && ' (Primary)'}
                                          </span>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )} */}
                                <div className="bg-gray-100 rounded p-3 mb-2">
                                  <p className="text-sm font-medium text-gray-700 mb-1">
                                    Code:
                                  </p>
                                  <pre className="bg-black text-white text-xs rounded p-2 overflow-x-auto mb-2">
                                    <code>{q.code}</code>
                                  </pre>
                                </div>
                                <div className="bg-gray-50 rounded p-3">
                                  <p className="text-sm font-medium text-gray-700 mb-3">
                                    Test Cases:
                                  </p>
                                  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 md:gap-4">
                                    {q.testCases && q.testCases.length > 0 ? (
                                      q.testCases.map((tc, tcIdx) => (
                                        <div
                                          key={tc._id || tcIdx}
                                          className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm flex flex-col gap-2"
                                        >
                                          <div className="flex items-center justify-between">
                                            <span className="text-xs font-semibold text-gray-600">
                                              Test Case {tcIdx + 1}
                                            </span>
                                            {tc.isVerified !== undefined && (
                                              <div
                                                className={`px-2 py-1 rounded-full text-xs font-medium ${
                                                  tc.isVerified
                                                    ? "bg-green-100 text-green-800"
                                                    : "bg-red-100 text-red-800"
                                                }`}
                                              >
                                                {tc.isVerified
                                                  ? "✓ Verified"
                                                  : "✗ Failed"}
                                              </div>
                                            )}
                                          </div>
                                          {tc.description && (
                                            <div className="text-xs text-gray-700">
                                              <span className="font-semibold">
                                                Description:
                                              </span>{" "}
                                              <span className="font-mono">
                                                {tc.description}
                                              </span>
                                            </div>
                                          )}
                                          <div className="text-xs text-gray-700">
                                            <span className="font-semibold">
                                              Input:
                                            </span>
                                            <span className="font-mono ml-1">
                                              {tc.input}
                                            </span>
                                          </div>
                                          <div className="text-xs text-gray-700">
                                            <span className="font-semibold">
                                              Expected Output:
                                            </span>
                                            <span className="font-mono ml-1">
                                              {tc.expectedOutput}
                                            </span>
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="text-xs text-gray-400">
                                        No test cases provided.
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col md:flex-row justify-end mt-6 gap-2 md:gap-4">
              <button
                onClick={() => setShowQuestionsPopup(false)}
                className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors w-full md:w-auto"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Manual Question Modal */}
      {showManualQuestionModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl mx-2 p-6 relative overflow-y-auto max-h-[90vh] transition-all duration-200">
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 focus:outline-none"
              onClick={() => setShowManualQuestionModal(false)}
              disabled={manualFormLoading}
              aria-label="Close modal"
            >
              <AiOutlineClose size={24} />
            </button>
            <h2 className="text-2xl font-bold mb-6 text-center text-gray-900">
              Add Coding Question Manually
            </h2>
            <form onSubmit={handleManualFormSubmit} className="space-y-2">
              <div className="">
                <label
                  className="block text-base font-medium mb-1 text-gray-800"
                  htmlFor="manual-question"
                >
                  Question<span className="text-red-500">*</span>
                </label>
                <input
                  id="manual-question"
                  className={`w-full border rounded-lg p-3 text-base focus:outline-primary placeholder-gray-400 ${
                    manualFormError && !manualForm.question.trim()
                      ? "border-red-400"
                      : ""
                  }`}
                  rows={2}
                  value={manualForm.question}
                  onChange={(e) =>
                    setManualForm((f) => ({ ...f, question: e.target.value }))
                  }
                  disabled={manualFormLoading}
                  required
                  placeholder="e.g. Write a function to reverse a string"
                  aria-label="Question"
                />
              </div>
              <div className="">
                <div className="flex items-center justify-between">
                  <label
                    className="block text-base font-medium mb-1 text-gray-800"
                    htmlFor="manual-code"
                  >
                    Code<span className="text-red-500">*</span>
                  </label>
                  <button
                    type="button"
                    className="px-3 py-1.5  text-primary rounded text-xs font-semibold transition-colors disabled:opacity-50 flex items-center gap-1"
                    onClick={handleAutoGenerateCode}
                    disabled={manualFormLoading || !manualForm.question.trim()}
                  >
                    <span className="text-xs">
                      <MdOutlineAutoAwesome />
                    </span>
                    {manualFormLoading ? "Generating..." : "Auto Generate"}
                  </button>
                </div>
                <textarea
                  id="manual-code"
                  className={`w-full border rounded-lg p-3 bg-black text-white text-base font-mono focus:outline-primary placeholder-gray-400 ${
                    manualFormError && !manualForm.code.trim()
                      ? "border-red-400"
                      : ""
                  }`}
                  rows={5}
                  value={manualForm.code}
                  onChange={(e) =>
                    setManualForm((f) => ({
                      ...f,
                      code: e.target.value,
                      testCases: f.testCases.map((tc) => ({
                        ...tc,
                        isVerified: undefined,
                      })),
                    }))
                  }
                  disabled={manualFormLoading}
                  required
                  placeholder="e.g. function reverseString(str) { ... }"
                  aria-label="Code"
                />
              </div>
              <div className="">
                <label
                  className="block text-base font-medium mb-1 text-gray-800"
                  htmlFor="manual-explanation"
                >
                  Explanation<span className="text-red-500">*</span>
                </label>
                <textarea
                  id="manual-explanation"
                  className={`w-full border rounded-lg p-3 text-base focus:outline-primary placeholder-gray-400 ${
                    manualFormError && !manualForm.explanation.trim()
                      ? "border-red-400"
                      : ""
                  }`}
                  rows={2}
                  value={manualForm.explanation}
                  onChange={(e) =>
                    setManualForm((f) => ({
                      ...f,
                      explanation: e.target.value,
                    }))
                  }
                  disabled={manualFormLoading}
                  required
                  placeholder="e.g. This function takes a string and returns its reverse."
                  aria-label="Explanation"
                />
              </div>
              <div className="">
                <label className="block text-base font-medium mb-1 text-gray-800">
                  Supported Languages<span className="text-red-500">*</span>
                </label>
                <div className="flex gap-2 mb-2">
                  <button
                    type="button"
                    onClick={() => {
                      const currentLanguageId = parseInt(
                        RecuiterStore.jobPostDetails.taskDetails.languageId,
                      );
                      const allLanguageIds = LANGUAGES.map((lang) => lang.id);
                      setManualForm((f) => ({
                        ...f,
                        supportedLanguageIds: currentLanguageId
                          ? [...new Set([...allLanguageIds, currentLanguageId])]
                          : allLanguageIds,
                      }));
                    }}
                    disabled={manualFormLoading}
                    className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors"
                  >
                    Select All
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      const currentLanguageId = parseInt(
                        RecuiterStore.jobPostDetails.taskDetails.languageId,
                      );
                      setManualForm((f) => ({
                        ...f,
                        supportedLanguageIds: currentLanguageId
                          ? [currentLanguageId]
                          : [],
                      }));
                    }}
                    disabled={manualFormLoading}
                    className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition-colors"
                  >
                    Clear All
                  </button>
                  <span className="text-xs text-gray-500 ml-auto self-center">
                    {manualForm.supportedLanguageIds.length} selected
                  </span>
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 max-h-48 overflow-y-auto">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {LANGUAGES.map((lang) => {
                      const isCurrentLanguage =
                        lang.id ===
                        parseInt(
                          RecuiterStore.jobPostDetails.taskDetails.languageId,
                        );
                      return (
                        <label
                          key={lang.id}
                          className={`flex items-center space-x-2 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition-colors ${
                            isCurrentLanguage
                              ? "bg-blue-50 border border-blue-200"
                              : ""
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={manualForm.supportedLanguageIds.includes(
                              lang.id,
                            )}
                            onChange={(e) => {
                              handleSupportedLanguageChange(
                                lang.id,
                                e.target.checked,
                              );
                            }}
                            disabled={manualFormLoading || isCurrentLanguage}
                            className="text-primary focus:ring-primary"
                          />
                          <span className="text-sm text-gray-700 flex-1">
                            {lang.name}
                          </span>
                          {isCurrentLanguage && (
                            <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                              Required
                            </span>
                          )}
                        </label>
                      );
                    })}
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Select all languages that support this coding question. The
                  question will be available for candidates using any of the
                  selected languages. The current language is highlighted and
                  must be included.
                </p>
              </div>
              <div className="">
                <div className="flex items-center justify-between mb-3">
                  <label className="block text-base font-medium mb-1 text-gray-800">
                    Test Cases<span className="text-red-500">*</span>
                  </label>{" "}
                  <button
                    type="button"
                    className="px-3 py-1.5 bg-green-600 text-white rounded text-xs hover:bg-green-700 transition-colors disabled:opacity-50"
                    onClick={handleVerifyAllTestCases}
                    disabled={manualFormLoading || !manualForm.code.trim()}
                  >
                    {manualFormLoading ? "Verifying..." : "Verify All"}
                  </button>
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-xl p-3">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex-1">Input</div>
                    <div className="flex-1">Expected Output</div>
                    <div className="flex-1">Description</div>
                    <div className="w-8"></div>
                  </div>
                  <div className="space-y-1">
                    {manualForm.testCases.map((tc, idx) => (
                      <div
                        key={idx}
                        className="flex items-center gap-2 border border-gray-100 rounded-lg bg-white p-2 transition-shadow focus-within:shadow-md"
                      >
                        <textarea
                          className={`flex-1 border min-h-10 max-h-20 rounded-md p-2 text-xs font-mono focus:outline-primary ${
                            manualFormError && !tc.input.trim()
                              ? "border-red-400"
                              : ""
                          }`}
                          placeholder="e.g. 'hello'"
                          value={tc.input}
                          onChange={(e) =>
                            handleTestCaseChange(idx, "input", e.target.value)
                          }
                          disabled={manualFormLoading}
                          // required
                          aria-label={`Test case ${idx + 1} input`}
                          autoFocus={
                            idx === manualForm.testCases.length - 1 &&
                            manualForm.testCases.length > 1
                          }
                        />
                        <textarea
                          className={`flex-1 border min-h-10 max-h-20 rounded-md p-2 text-xs font-mono focus:outline-primary ${
                            manualFormError && !tc.expectedOutput.trim()
                              ? "border-red-400"
                              : ""
                          }`}
                          placeholder="e.g. 'olleh'"
                          value={tc.expectedOutput}
                          onChange={(e) =>
                            handleTestCaseChange(
                              idx,
                              "expectedOutput",
                              e.target.value,
                            )
                          }
                          disabled={manualFormLoading}
                          // required
                          aria-label={`Test case ${idx + 1} expected output`}
                        />
                        <textarea
                          className="flex-1 border min-h-10 max-h-20 rounded-md p-2 text-xs focus:outline-primary"
                          placeholder="e.g. Reverse a simple string"
                          value={tc.description}
                          onChange={(e) =>
                            handleTestCaseChange(
                              idx,
                              "description",
                              e.target.value,
                            )
                          }
                          disabled={manualFormLoading}
                          aria-label={`Test case ${idx + 1} description`}
                        />
                        <div className="flex items-center ">
                          {/* Verification Status Indicator */}
                          {/* Verify Button */}
                          <button
                            type="button"
                            className={`px-2 py-1 rounded text-xs transition-colors ${
                              verifyingTestCases[idx] === "verifying"
                                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                : verifyingTestCases[idx] === "verified"
                                  ? "bg-green-600 text-white hover:bg-green-700"
                                  : verifyingTestCases[idx] === "failed"
                                    ? "bg-red-600 text-white hover:bg-red-700"
                                    : tc.isVerified
                                      ? "bg-green-600 text-white hover:bg-green-700"
                                      : "bg-blue-600 text-white hover:bg-blue-700"
                            }`}
                            onClick={() => handleVerifyTestCase(idx)}
                            disabled={
                              manualFormLoading ||
                              verifyingTestCases[idx] === "verifying" ||
                              !manualForm.code.trim() ||
                              tc.isVerified === true
                            }
                            aria-label={`Verify test case ${idx + 1}`}
                          >
                            {verifyingTestCases[idx] === "verifying"
                              ? "Verifying..."
                              : verifyingTestCases[idx] === "verified"
                                ? "Verified"
                                : verifyingTestCases[idx] === "failed"
                                  ? "Failed"
                                  : tc.isVerified
                                    ? "Verified"
                                    : "Verify"}
                          </button>
                          {/* Remove Button */}
                          <button
                            type="button"
                            className="text-red-500 hover:text-red-700 px-2 focus:outline-none"
                            onClick={() => handleRemoveTestCase(idx)}
                            disabled={
                              manualFormLoading ||
                              manualForm.testCases.length === 1
                            }
                            aria-label={`Remove test case ${idx + 1}`}
                          >
                            <FiTrash2 size={18} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    className="text-primary hover:text-primary-dark text-xs mt-2 font-semibold focus:outline-none"
                    onClick={handleAddTestCase}
                    disabled={manualFormLoading}
                    aria-label="Add test case"
                  >
                    + Add Test Case
                  </button>
                  <span className="block text-xs text-gray-500 mt-2">
                    Add at least one test case. Each test case should have input
                    and expected output. Use the verify buttons to test your
                    code against the test cases.
                  </span>
                  {manualForm.testCases.some(
                    (tc) => tc.isVerified !== undefined,
                  ) && (
                    <div className="mt-3 p-2 bg-blue-50 border border-blue-200 rounded-lg">
                      <div className="text-xs font-medium text-blue-900 mb-1">
                        Verification Summary:
                      </div>
                      <div className="flex gap-4 text-xs text-blue-700">
                        <span>
                          ✅ Verified:{" "}
                          {
                            manualForm.testCases.filter(
                              (tc) => tc.isVerified === true,
                            ).length
                          }
                        </span>
                        <span>
                          ❌ Failed:{" "}
                          {
                            manualForm.testCases.filter(
                              (tc) => tc.isVerified === false,
                            ).length
                          }
                        </span>
                        <span>
                          ⏳ Pending:{" "}
                          {
                            manualForm.testCases.filter(
                              (tc) => tc.isVerified === undefined,
                            ).length
                          }
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {manualFormError && (
                <div className="text-red-500 text-sm text-center mt-2">
                  {manualFormError}
                </div>
              )}
              <div className="flex flex-col md:flex-row justify-end gap-2 mt-6">
                <button
                  type="button"
                  className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300 w-full md:w-auto font-semibold focus:outline-none"
                  onClick={() => setShowManualQuestionModal(false)}
                  disabled={manualFormLoading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary-dark disabled:opacity-60 w-full md:w-auto font-semibold flex items-center justify-center gap-2 focus:outline-none"
                  disabled={manualFormLoading}
                  aria-busy={manualFormLoading}
                >
                  {manualFormLoading && (
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      ></path>
                    </svg>
                  )}
                  {manualFormLoading ? "Saving..." : "Save Question"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  ));
}
